var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('customer-form',{attrs:{"id":_vm.$route.params.id},on:{"success":function($event){return _vm.goBack()},"cancel":function($event){return _vm.goBack()}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }